import { render, staticRenderFns } from "./CarrinhosAbandonados.vue?vue&type=template&id=ad004ada&scoped=true&"
import script from "./CarrinhosAbandonados.vue?vue&type=script&lang=js&"
export * from "./CarrinhosAbandonados.vue?vue&type=script&lang=js&"
import style0 from "./CarrinhosAbandonados.vue?vue&type=style&index=0&id=ad004ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad004ada",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VFlex,VIcon,VLayout,VTextField})


/* vuetify-loader */
import installDirectives from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import { Ripple } from 'vuetify/lib/directives'
installDirectives(component, {Ripple})
